import React from "react";
import "./RecentPhotosModal.css";

// Phase I. Tapped from the "Recent photos" circle on the dashboard
// strip. Shows up to 5 newest event photos. Read-only — uploads /
// management happen in the existing Photos admin tab. The s3Key URL
// shape matches the rest of the app (S3 base + s3Key).

const S3_BASE = "https://s3.amazonaws.com/social-images-public/";

const formatTakenAt = (raw) => {
  if (!raw) return "";
  const d = new Date(raw);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleDateString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

const thumbKey = (s3Key) => {
  if (!s3Key) return null;
  // The eventImages pipeline writes <name>_thumb.jpg next to the
  // original. Falls back via onError below if the thumb hasn't been
  // generated for an older photo.
  return s3Key.replace(/(\.[a-zA-Z0-9]+)$/, "_thumb$1");
};

const RecentPhotosModal = ({ photos, onClose }) => {
  return (
    <div
      className="recent-photos__backdrop"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
    >
      <div
        className="recent-photos__panel"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="recent-photos__header">
          <h3 className="recent-photos__title">Recent photos</h3>
          <button
            type="button"
            className="recent-photos__close"
            onClick={onClose}
            aria-label="Close"
          >
            ×
          </button>
        </div>
        {photos.length === 0 ? (
          <p className="recent-photos__muted">No photos yet.</p>
        ) : (
          <div className="recent-photos__grid">
            {photos.map((p) => {
              const fullUrl = `${S3_BASE}${p.s3Key}`;
              const thumb = thumbKey(p.s3Key);
              return (
                <a
                  key={p.s3Key}
                  href={fullUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="recent-photos__tile"
                  title={p.displayName || ""}
                >
                  <img
                    src={thumb ? `${S3_BASE}${thumb}` : fullUrl}
                    onError={(e) => {
                      if (e.currentTarget.src !== fullUrl) {
                        e.currentTarget.src = fullUrl;
                      }
                    }}
                    alt={p.displayName || "Recent event photo"}
                    loading="lazy"
                  />
                  <div className="recent-photos__caption">
                    <div className="recent-photos__name">
                      {p.displayName || ""}
                    </div>
                    <div className="recent-photos__date">
                      {formatTakenAt(p.takenAt || p.uploadedAt)}
                    </div>
                  </div>
                </a>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default RecentPhotosModal;
